// Test IDs for Precision Woodworking Artistry landing page
export const PWA = {
  // Nav
  navBar: "pwa-nav-bar",
  navLogo: "pwa-nav-logo",
  navLinkHome: "pwa-nav-link-home",
  navLinkAbout: "pwa-nav-link-about",
  navLinkServices: "pwa-nav-link-services",
  navLinkGallery: "pwa-nav-link-gallery",
  navLinkProcess: "pwa-nav-link-process",
  navLinkFaq: "pwa-nav-link-faq",
  navCtaQuote: "pwa-nav-cta-quote",
  navMobileToggle: "pwa-nav-mobile-toggle",
  navMobileMenu: "pwa-nav-mobile-menu",

  // Hero
  heroSection: "pwa-hero-section",
  heroLogo: "pwa-hero-logo",
  heroHeadline: "pwa-hero-headline",
  heroCtaQuote: "pwa-hero-cta-quote",
  heroCtaWork: "pwa-hero-cta-work",

  // About
  aboutSection: "pwa-about-section",
  aboutImage: "pwa-about-image",

  // Services
  servicesSection: "pwa-services-section",
  serviceCard: (key) => `pwa-service-card-${key}`,
  serviceQuoteCta: (key) => `pwa-service-quote-${key}`,

  // Gallery
  gallerySection: "pwa-gallery-section",
  galleryFilter: (key) => `pwa-gallery-filter-${key}`,
  galleryItem: (key) => `pwa-gallery-item-${key}`,

  // Process
  processSection: "pwa-process-section",

  // Why Choose Us
  whySection: "pwa-why-section",

  // Testimonials
  testimonialsSection: "pwa-testimonials-section",
  testimonialPrev: "pwa-testimonial-prev",
  testimonialNext: "pwa-testimonial-next",

  // Quote form
  quoteFormSection: "pwa-quote-form-section",
  quoteFormName: "pwa-quote-form-name",
  quoteFormPhone: "pwa-quote-form-phone",
  quoteFormEmail: "pwa-quote-form-email",
  quoteFormProjectType: "pwa-quote-form-project-type",
  quoteFormBudget: "pwa-quote-form-budget",
  quoteFormTimeline: "pwa-quote-form-timeline",
  quoteFormDetails: "pwa-quote-form-details",
  quoteFormUpload: "pwa-quote-form-upload",
  quoteFormSubmit: "pwa-quote-form-submit",
  quoteFormSuccess: "pwa-quote-form-success",

  // Final CTA
  finalCtaSection: "pwa-final-cta-section",
  finalCtaButton: "pwa-final-cta-button",

  // FAQ
  faqSection: "pwa-faq-section",
  faqItem: (key) => `pwa-faq-item-${key}`,

  // Footer
  footer: "pwa-footer",
  footerPhone: "pwa-footer-phone",
  footerSocial: (key) => `pwa-footer-social-${key}`,
};
